import { render, staticRenderFns } from "./GroupOrderInfo.vue?vue&type=template&id=6d719e02&scoped=true&"
import script from "./GroupOrderInfo.vue?vue&type=script&lang=js&"
export * from "./GroupOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./GroupOrderInfo.vue?vue&type=style&index=0&id=6d719e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d719e02",
  null
  
)

export default component.exports